module.exports = __webpack_public_path__ + "img/certified-repairs@2x.524a6efd.jpg";